import React, { Suspense, lazy } from 'react';
import { Loader } from 'src/domains/layouts/webview/components/loader/Loader';
import { LoaderWrapper } from 'src/domains/players/state/IdMission/IdMissionPopup/IdMissionPopup.style';
import { IdMissionValidationType } from './IdMissionValidation';

const IdMissionValidation = lazy(() =>
    import('./IdMissionValidation').then((module) => ({
        default: module.IdMissionValidation,
    }))
);

export const IdMissionValidationLazy = (props: IdMissionValidationType): JSX.Element => {
    return (
        <Suspense
            fallback={
                <LoaderWrapper>
                    <Loader size={24} />
                </LoaderWrapper>
            }
        >
            <IdMissionValidation {...props} />
        </Suspense>
    );
};
